import { CircularProgressbar } from 'react-circular-progressbar';
import clsx from 'clsx';
import 'react-circular-progressbar/dist/styles.css';
import { ProgressStep } from '../progressStep';
import css from './CircleProgressIndicator.module.css';
import { H2, Paragraph } from '../../text';
import {
  StackedColumn,
  StackedColumnSpacing,
} from '../../containers/stackedColumn';
import { StackedRow } from '../../containers/stackedRow';
import { ImageTextLink } from '../../links';
import { ChevronLeftBlueImage } from '../../../assets/images';
import { ImageAlignment } from '../../../models';

export interface CircleProgressIndicatorProps {
  steps: ProgressStep[];
  activeStepIndex: number;
  percentComplete: number;
  onBackClicked?: () => void;
}

const CircleProgressIndicator: React.FC<CircleProgressIndicatorProps> = (
  props: CircleProgressIndicatorProps
) => {
  const { steps = [], activeStepIndex = 0 } = props;
  const activeStep: ProgressStep | undefined =
    activeStepIndex < steps.length ? steps[activeStepIndex] : undefined;
  let nextStepText: string | undefined = undefined;
  if (activeStep?.overrideNextStep) {
    nextStepText = activeStep?.overrideNextStep;
  } else if (activeStepIndex < steps.length - 1) {
    nextStepText = steps[activeStepIndex + 1].name;
  }

  const onBackClicked = () => {
    props.onBackClicked && props.onBackClicked();
  };

  return (
    <div className={css.container}>
      <StackedRow>
        <div className={css.backButtonContainer}>
          {activeStepIndex > 0 ? (
            <ImageTextLink
              imageSource={ChevronLeftBlueImage}
              caption="Back"
              onClick={onBackClicked}
              imageAlignment={ImageAlignment.Left}
            />
          ) : null}
        </div>
        <div className={css.progressBarContainer}>
          <CircularProgressbar
            value={props.percentComplete}
            maxValue={100}
            className={css.bar}
            strokeWidth={12}
            classes={{
              root: 'CircularProgressbar',
              trail: 'CircularProgressbar-trail',
              path: clsx('CircularProgressbar-path', css.customPath),
              text: 'CircularProgressbar-text',
              background: 'CircularProgressbar-background',
            }}
            styles={{
              path: {
                stroke: 'var(--color-circle-progress-complete)',
              },
              trail: {
                stroke: 'var(--color-circle-progress-incomplete)',
              },
            }}
          />
        </div>
        <StackedColumn fillHeight={true} spacing={StackedColumnSpacing.Tight}>
          {activeStep ? <H2 text={activeStep.name} /> : null}
          {nextStepText ? (
            <Paragraph text={`Next Step: ${nextStepText}`} />
          ) : null}
        </StackedColumn>
      </StackedRow>
    </div>
  );
};

export default CircleProgressIndicator;
